import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "help",
  "use": "help-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"help\"><title>help</title><g id=\"help_Layer_8\" data-name=\"Layer 8\"><circle cx=\"10.5\" cy=\"18.5\" r=\"1\" /><path d=\"M10.5,16a.5.5,0,0,1-.5-.5V12.7622a1.5486,1.5486,0,0,1,1.2773-1.5142,4.2588,4.2588,0,0,0,3.3741-5.1118,4.2275,4.2275,0,0,0-3.2188-3.2187,4.29,4.29,0,0,0-3.6074.8481A4.2367,4.2367,0,0,0,6.25,7.0688a.5.5,0,0,1-1,0,5.25,5.25,0,1,1,6.209,5.1626.5418.5418,0,0,0-.459.5308V15.5A.5.5,0,0,1,10.5,16Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/help.svg
// module id = ijvn
// module chunks = 4